import React from 'react';
import './styles.css';

const EmptyList = () => (
  <div className='emptyList-wrap'>
    <h1>Couldn't find bruh</h1>
  </div>
);

export default EmptyList;
